import React from 'react';
//import Accordion from 'react-bootstrap/Accordion';
//import Card from 'react-bootstrap/Card'; 
//import MyCards from './MyCards';
//import MyCardGroup from './MyCardGroup';
import NewsAPI from './NewsAPI';


function BodyContent(){
	return (
		<div>
			
			<NewsAPI />
		</div>
		);
}

export default BodyContent;